
namespace TabAurous.Administration {

    @Serenity.Decorators.registerClass()
    export class IntegrationDialog extends Serenity.EntityDialog<IntegrationRow, any> {
        protected getFormKey() { return IntegrationForm.formKey; }
        protected getIdProperty() { return IntegrationRow.idProperty; }
        protected getLocalTextPrefix() { return IntegrationRow.localTextPrefix; }
        protected getNameProperty() { return IntegrationRow.nameProperty; }
        protected getService() { return IntegrationService.baseUrl; }
        protected getDeletePermission() { return IntegrationRow.deletePermission; }
        protected getInsertPermission() { return IntegrationRow.insertPermission; }
        protected getUpdatePermission() { return IntegrationRow.updatePermission; }

        protected form = new IntegrationForm(this.idPrefix);
        constructor() {
            super();
            this.form.Type.changeSelect2(e => {
                var type = this.form.Type.value;
                var items = this.form.IntegrationType.items;
                this.form.IntegrationType.cascadeField = "Num1";
                this.form.IntegrationType.cascadeValue= type;
            })
        }
    }
}